<template>
	<div class="sip-view-page">
        <div class="nk-block-head nk-block-head-sm sip-view-head">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('general.support') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Contact support with product metadata attached automatically.</p>
                    </div>
                </div>
                <span class="admin-status-badge" :class="product.name && !checkSupportValidity ? 'admin-status-badge--danger' : 'admin-status-badge--success'">
                    {{ product.name && !checkSupportValidity ? 'Expired' : 'Available' }}
                </span>
            </div>
        </div>

        <div class="row sip-view-grid">
            <div class="col-12 col-lg-8">
                <div class="card sip-view-card">
                    <div class="card-body">
                <div class="sip-view-note sip-view-note--danger" v-if="product.name && !checkSupportValidity">
                    <strong>Your support is expired.</strong>
                    <span>Please renew your support before opening a new request.</span>
                </div>
                <div v-else>
                    <div class="sip-view-rich" v-html="support_tips"></div>
                    <form class="mt-3" @submit.prevent="submit" @keydown="supportForm.errors.clear($event.target.name)">
                        <div class="form-group">
                            <label>Subject</label>
                            <input class="form-control" type="text" value="" v-model="supportForm.subject" name="subject" placeholder="Subject">
                            <show-error :form-name="supportForm" prop-name="subject"></show-error>
                        </div>
                        <div class="form-group">
                            <label>Body</label>
                            <autosize-textarea rows="5" class="form-control" v-model="supportForm.body" placeholder="Body" name="body"></autosize-textarea>
                            <show-error :form-name="supportForm" prop-name="body"></show-error>
                        </div>
                        <div class="sip-view-actions">
                            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">Submit</button>
                        </div>
                    </form>
                </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="card sip-view-card">
                    <div class="card-body">
                        <product :product="product"></product>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import product from './product'
    import autosizeTextarea from '../../components/autosize-textarea'

	export default {
		components: {product,autosizeTextarea},
		data() {
			return {
                support_tips: '',
				product: {},
				supportForm: new Form({
					subject: '',
					body: '',
					purchase_code: '',
					product_name: '',
					date_of_support_expiry: ''
				})
			}
		},
		mounted(){
			if(!helper.hasRole('admin')) {
				this.$router.push('/');
			}

            toastr.success(i18n.general.wait_while_loading);
			axios.get('/api/support')
				.then(response => response.data)
				.then(response => {
                    this.support_tips = response.support_tips;
					this.product = response.product;
					this.supportForm.purchase_code = this.product.purchase_code;
					this.supportForm.product_name = this.product.name;
					this.supportForm.date_of_support_expiry = this.product.date_of_support_expiry;
				})
				.catch(error => {
					helper.showDataErrorMsg(error);
				})
		},
		methods: {
			submit(){
				this.supportForm.post('/api/support')
					.then(response => {
						toastr.success(response.message);
					})
					.catch(error => {
						helper.showErrorMsg(error);
					});
			}
		},
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        },
        computed: {
            checkSupportValidity(){
                if (moment().format('YYYY-MM-DD') <= this.product.date_of_support_expiry)
                    return true;
                else
                    return false;
            }
        }
	}
</script>
